import { render, staticRenderFns } from "./NewInterests.vue?vue&type=template&id=4e78990c&scoped=true&"
import script from "./NewInterests.vue?vue&type=script&lang=js&"
export * from "./NewInterests.vue?vue&type=script&lang=js&"
import style0 from "./NewInterests.vue?vue&type=style&index=0&id=4e78990c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e78990c",
  null
  
)

export default component.exports